import React from "react";

// Shown to a connected buyer while the seller has the "Change price" dialog open — or is editing the
// odometer reading / number of keys (field = "odometer" | "keysCount"), with that field's own wording.
export default function PriceLockOverlay({ t, field }) {
  const key = field ? `buyer.fieldLock.${field}` : "buyer.priceLock";
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="price-lock-title"
      className="fixed inset-0 z-[80] flex items-center justify-center bg-[rgba(10,20,26,.55)] px-4"
    >
      <div className="ds-scope w-full max-w-sm rounded-[14px] border border-ds-sheet-edge bg-ds-sheet p-6 text-center shadow-[0_12px_30px_rgba(10,20,26,.3)]">
        <div
          className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-ds-rule-edge"
          style={{ borderTopColor: "var(--ds-green)" }}
          aria-hidden="true"
        />
        <h2 id="price-lock-title" className="ds-title-component m-0 mb-1.5">
          {t(`${key}.title`)}
        </h2>
        <p className="ds-body m-0 text-sm">{t(`${key}.body`)}</p>
      </div>
    </div>
  );
}
